import { action, makeObservable, observable, runInAction } from "mobx";
import { DefaultRequestStatus, RequestStatus } from "../../shared/api/RequestStatus";
import { BusinessLine } from "../../shared/types/BusinessLine";
import { LanguageVersion } from "../../shared/types/LanguageVersion";
import userService, { UserService } from "../service/UserService";

export interface UserStore {
    businessLines: BusinessLine[];
    languageVersion: LanguageVersion;

    loadBusinessLinesRequestStatus: RequestStatus;

    loadBusinessLines: () => Promise<void>;
}

export class DefaultUserStore implements UserStore {
    constructor(private service: UserService, private loadBusinessLinesReqStatus: RequestStatus) {
        makeObservable(this, {
            loadBusinessLines: action,
            languageVersion: observable,
            businessLines: observable,
        });
    }

    public businessLines: BusinessLine[] = [];

    public languageVersion: LanguageVersion = LanguageVersion.Polish;

    public get loadBusinessLinesRequestStatus() {
        return this.loadBusinessLinesReqStatus;
    }

    public async loadBusinessLines() {
        const response = await this.loadBusinessLinesReqStatus.handleAnyRequest(() => this.service.getBusinessLines());

        runInAction(() => {
            if (response) {
                this.businessLines = response.businessLines;
                this.languageVersion = response.languageVersion;
            }
        });
    }
}

export default new DefaultUserStore(userService, new DefaultRequestStatus());
